"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.BlockButtonParams = exports.BlockButtonTopEditor = exports.BlockButton = void 0;

var _react = _interopRequireWildcard(require("react"));

var _react2 = require("@chakra-ui/react");

var _immer = _interopRequireDefault(require("immer"));

var _io = require("react-icons/io5");

var _recoil = require("recoil");

var _RecoilStates = require("../../contexts/RecoilStates");

var _ColorPalette = require("../ColorPalette");

var _ParamsPaddingButton = require("../ParamsPaddingButton");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var __jsx = _react["default"].createElement;

/**
 * @param {import("../../../types/types").BlockProps<import("../../../types/blocks").BlockButton>} props
 */
var BlockButton = function BlockButton(_ref) {
  var block = _ref.block;
  var document = (0, _recoil.useRecoilValue)(_RecoilStates.DocumentState);
  var language = (0, _recoil.useRecoilValue)(_RecoilStates.LanguageState);
  var text = (0, _react.useMemo)(function () {
    var _block$content$intl$l, _block$content$intl$l2, _block$content$intl$d;

    return (_block$content$intl$l = (_block$content$intl$l2 = block.content.intl[language.key]) == null ? void 0 : _block$content$intl$l2.text) != null ? _block$content$intl$l : (_block$content$intl$d = block.content.intl[document.language]) == null ? void 0 : _block$content$intl$d.text;
  }, [block.content.intl, document.language, language.key]);
  var useCustomPaddings = (0, _react.useMemo)(function () {
    var _block$content$useCus;

    return (_block$content$useCus = block.content.useCustomPaddings) != null ? _block$content$useCus : true;
  }, [block.content.useCustomPaddings]);
  var height = (0, _react.useMemo)(function () {
    return useCustomPaddings ? "auto" : undefined;
  }, [useCustomPaddings]);
  return __jsx(_react2.Button, {
    pointerEvents: "none",
    width: "100%",
    height: height,
    variant: block.content.variant,
    size: block.content.size,
    colorScheme: block.content.colorScheme,
    paddingTop: useCustomPaddings && block.content.paddingTop ? "".concat(block.content.paddingTop, "px") : undefined,
    paddingRight: useCustomPaddings && block.content.paddingRight ? "".concat(block.content.paddingRight, "px") : undefined,
    paddingBottom: useCustomPaddings && block.content.paddingBottom ? "".concat(block.content.paddingBottom, "px") : undefined,
    paddingLeft: useCustomPaddings && block.content.paddingLeft ? "".concat(block.content.paddingLeft, "px") : undefined,
    backgroundColor: block.content.backgroundColor,
    _hover: {
      backgroundColor: block.content.backgroundColor
    },
    borderRadius: block.content.borderRadius ? "".concat(block.content.borderRadius, "px") : undefined,
    borderWidth: block.content.borderWidth ? "".concat(block.content.borderWidth, "px") : undefined,
    whiteSpace: block.content.whiteSpace,
    borderColor: block.content.borderWidth ? block.content.borderColor : undefined,
    color: block.content.color
  }, text);
};
/**
 * @param {import("../../../types/types").BlockSubComponentProps<import("../../../types/blocks").BlockButton>} props
 */


exports.BlockButton = BlockButton;

var BlockButtonTopEditor = function BlockButtonTopEditor(_ref2) {
  var _block$content$intl$l3, _block$content$intl$l4, _block$content$intl$d2, _block$content$intl$l5, _block$content$intl$l6, _block$content$intl$d3, _block$content$intl$l7, _block$content$intl$l8;

  var block = _ref2.block,
      onUpdate = _ref2.onUpdate;
  var document = (0, _recoil.useRecoilValue)(_RecoilStates.DocumentState);
  var language = (0, _recoil.useRecoilValue)(_RecoilStates.LanguageState);
  var text = (_block$content$intl$l3 = (_block$content$intl$l4 = block.content.intl[language.key]) == null ? void 0 : _block$content$intl$l4.text) != null ? _block$content$intl$l3 : (_block$content$intl$d2 = block.content.intl[document.language]) == null ? void 0 : _block$content$intl$d2.text;
  var url = (_block$content$intl$l5 = (_block$content$intl$l6 = block.content.intl[language.key]) == null ? void 0 : _block$content$intl$l6.url) != null ? _block$content$intl$l5 : (_block$content$intl$d3 = block.content.intl[document.language]) == null ? void 0 : _block$content$intl$d3.url;

  var updateContentProps = function updateContentProps(changes) {
    var _block = (0, _immer["default"])(block, function (draft) {
      Object.keys(changes).forEach(function (key) {
        draft.content[key] = changes[key];
      });
    });

    onUpdate(_block);
  };

  var onInputTextChange = function onInputTextChange(event) {
    var _block = (0, _immer["default"])(block, function (draft) {
      if (!draft.content.intl[language.key]) {
        draft.content.intl[language.key] = {
          url: null,
          text: ""
        };
      }

      draft.content.intl[language.key].text = event.target.value;
    });

    onUpdate(_block);
  };

  var onInputUrlChange = function onInputUrlChange(event) {
    var _block = (0, _immer["default"])(block, function (draft) {
      if (!draft.content.intl[language.key]) {
        draft.content.intl[language.key] = {
          url: "",
          text: null
        };
      }

      draft.content.intl[language.key].url = event.target.value;
    });

    onUpdate(_block);
  };

  return __jsx(_react2.Stack, null, __jsx(_react2.Box, null, __jsx(_react2.Input, {
    value: text != null ? text : "",
    onChange: onInputTextChange,
    placeholder: "Text",
    variant: "filled"
  }), __jsx(_react2.Collapse, {
    "in": !((_block$content$intl$l7 = block.content.intl[language.key]) != null && _block$content$intl$l7.text)
  }, __jsx(_react2.Flex, {
    ml: "4",
    alignItems: "center",
    color: "gray.400"
  }, __jsx(_react2.Icon, {
    as: _io.IoChevronForwardOutline
  }), __jsx(_react2.Text, null, "Valeur par d\xE9faut utilis\xE9e")))), __jsx(_react2.Box, null, __jsx(_react2.Input, {
    value: url != null ? url : "",
    onChange: onInputUrlChange,
    placeholder: "https://...",
    variant: "filled"
  }), __jsx(_react2.Collapse, {
    "in": !((_block$content$intl$l8 = block.content.intl[language.key]) != null && _block$content$intl$l8.url)
  }, __jsx(_react2.Flex, {
    ml: "4",
    alignItems: "center",
    color: "gray.400"
  }, __jsx(_react2.Icon, {
    as: _io.IoChevronForwardOutline
  }), __jsx(_react2.Text, null, "Valeur par d\xE9faut utilis\xE9e")))), __jsx(_react2.Box, null, __jsx(_react2.FormControl, {
    display: "flex",
    alignItems: "center"
  }, __jsx(_react2.FormLabel, {
    flexGrow: 1,
    fontWeight: "normal",
    mb: "0",
    ml: "4",
    htmlFor: "switch-autoplay"
  }, "Ouvrir dans un nouvel onglet"), __jsx(_react2.Switch, {
    id: "switch-autoplay",
    isChecked: block.content.openInNewTab,
    onChange: function onChange(event) {
      return updateContentProps({
        openInNewTab: event.target.checked
      });
    }
  }))));
};
/**
 * @param {import("../../../types/types").BlockSubComponentProps<import("../../../types/blocks").BlockButton>} props
 */


exports.BlockButtonTopEditor = BlockButtonTopEditor;

var BlockButtonParams = function BlockButtonParams(_ref3) {
  var _block$content$colorS, _block$content$useCus2, _block$content$border;

  var block = _ref3.block,
      onUpdate = _ref3.onUpdate,
      colorSchemeOptions = _ref3.colorSchemeOptions;

  var updateContentProps = function updateContentProps(changes) {
    var _block = (0, _immer["default"])(block, function (draft) {
      Object.keys(changes).forEach(function (key) {
        draft.content[key] = changes[key];
      });
    });

    onUpdate(_block);
  };

  var _useState = (0, _react.useState)(false),
      useAdvancedMode = _useState[0],
      setUseAdvancedMode = _useState[1];

  return __jsx(_react2.Box, {
    w: "full"
  }, __jsx(_react2.Stack, {
    spacing: "8px"
  }, __jsx(_react2.Text, {
    fontWeight: "bold"
  }, "Bouton"), __jsx(_react2.Stack, {
    spacing: "8px"
  }, __jsx(_react2.Select, {
    variant: "filled",
    value: block.content.variant,
    onChange: function onChange(e) {
      updateContentProps({
        variant: e.target.value
      });
    },
    size: "sm"
  }, __jsx("option", {
    value: "outline"
  }, "Variante: Contour"), __jsx("option", {
    value: "ghost"
  }, "Variante: Fant\xF4me"), __jsx("option", {
    value: "link"
  }, "Variante: Lien"), __jsx("option", {
    value: "solid"
  }, "Variante: Solide"), __jsx("option", {
    value: "unstyled"
  }, "Variante: Sans style")), __jsx(_react2.Select, {
    variant: "filled",
    value: (_block$content$colorS = block.content.colorScheme) != null ? _block$content$colorS : "",
    onChange: function onChange(e) {
      updateContentProps({
        colorScheme: e.target.value ? e.target.value : undefined
      });
    },
    size: "sm"
  }, __jsx("option", {
    value: ""
  }, "Th\xE8me: Aucun"), colorSchemeOptions.map(function (colorSchemeOption, index) {
    return __jsx("option", {
      key: index,
      value: colorSchemeOption.value
    }, "Th\xE8me: ", colorSchemeOption.label);
  })), __jsx(_react2.Select, {
    variant: "filled",
    value: block.content.size,
    onChange: function onChange(e) {
      updateContentProps({
        size: e.target.value
      });
    },
    size: "sm"
  }, __jsx("option", {
    value: "xs"
  }, "Taille: Tr\xE8s petite"), __jsx("option", {
    value: "sm"
  }, "Taille: Petite"), __jsx("option", {
    value: "md"
  }, "Taille: Normale"), __jsx("option", {
    value: "lg"
  }, "Taille: Grande"))), __jsx(_react2.Box, null, __jsx(_react2.Checkbox, {
    isChecked: useAdvancedMode,
    onChange: function onChange() {
      setUseAdvancedMode(!useAdvancedMode);
    },
    size: "sm"
  }, "Mode avanc\xE9"))), __jsx(_react2.Collapse, {
    "in": useAdvancedMode,
    unmountOnExit: true
  }, __jsx(_react2.Box, {
    pt: "8px"
  }, __jsx(_react2.Accordion, {
    allowMultiple: true
  }, __jsx(_react2.AccordionItem, null, __jsx(_react2.AccordionButton, null, __jsx(_react2.Box, {
    flex: "1",
    textAlign: "left",
    fontWeight: "medium"
  }, "Marges int\xE9rieures"), __jsx(_react2.AccordionIcon, null)), __jsx(_react2.AccordionPanel, {
    pb: 4
  }, __jsx(_ParamsPaddingButton.ParamsPaddingButton, {
    paddingTop: block.content.paddingTop,
    paddingBottom: block.content.paddingBottom,
    paddingLeft: block.content.paddingLeft,
    paddingRight: block.content.paddingRight,
    useCustomPaddings: (_block$content$useCus2 = block.content.useCustomPaddings) != null ? _block$content$useCus2 : true,
    onUpdate: updateContentProps
  }))), __jsx(_react2.AccordionItem, null, __jsx(_react2.AccordionButton, null, __jsx(_react2.Box, {
    flex: "1",
    textAlign: "left",
    fontWeight: "medium"
  }, "Arri\xE8re-plan"), __jsx(_react2.AccordionIcon, null)), __jsx(_react2.AccordionPanel, {
    pb: 4
  }, __jsx(_react2.Stack, {
    my: "2"
  }, __jsx(_react2.InputGroup, {
    variant: "filled"
  }, __jsx(_react2.InputLeftElement, null, __jsx(_react2.Box, {
    width: "20px",
    height: "20px",
    backgroundColor: block.content.backgroundColor,
    transition: "background-color .25s ease"
  })), __jsx(_react2.Input, {
    onChange: function onChange(event) {
      return updateContentProps({
        backgroundColor: event.target.value
      });
    },
    value: block.content.backgroundColor,
    placeholder: "#000000"
  })), __jsx(_ColorPalette.ColorPalette, {
    currentColor: block.content.backgroundColor,
    onChange: function onChange(value) {
      return updateContentProps({
        backgroundColor: value
      });
    }
  })))), __jsx(_react2.AccordionItem, null, __jsx(_react2.AccordionButton, null, __jsx(_react2.Box, {
    flex: "1",
    textAlign: "left",
    fontWeight: "medium"
  }, "Texte"), __jsx(_react2.AccordionIcon, null)), __jsx(_react2.AccordionPanel, {
    pb: 4
  }, __jsx(_react2.Stack, {
    my: "2"
  }, __jsx(_react2.InputGroup, {
    variant: "filled"
  }, __jsx(_react2.InputLeftElement, null, __jsx(_react2.Box, {
    width: "20px",
    height: "20px",
    backgroundColor: block.content.color,
    transition: "background-color .25s ease"
  })), __jsx(_react2.Input, {
    onChange: function onChange(event) {
      return updateContentProps({
        color: event.target.value
      });
    },
    value: block.content.color,
    placeholder: "#000000"
  })), __jsx(_ColorPalette.ColorPalette, {
    currentColor: block.content.color,
    onChange: function onChange(value) {
      return updateContentProps({
        color: value
      });
    }
  })))), __jsx(_react2.AccordionItem, null, __jsx(_react2.AccordionButton, null, __jsx(_react2.Box, {
    flex: "1",
    textAlign: "left",
    fontWeight: "medium"
  }, "Bordures"), __jsx(_react2.AccordionIcon, null)), __jsx(_react2.AccordionPanel, {
    pb: 4
  }, __jsx(_react2.Stack, {
    direction: "row",
    justifyContent: "space-between"
  }, __jsx(_react2.FormControl, {
    mb: "4",
    width: "45%"
  }, __jsx(_react2.FormLabel, {
    fontWeight: "normal",
    mb: "4"
  }, "Rayon"), __jsx(_react2.NumberInput, {
    onChange: function onChange(valueStr, value) {
      return updateContentProps({
        borderRadius: value
      });
    },
    defaultValue: block.content.borderRadius,
    min: 0,
    max: 100,
    variant: "filled"
  }, __jsx(_react2.NumberInputField, null), __jsx(_react2.NumberInputStepper, null, __jsx(_react2.NumberIncrementStepper, null), __jsx(_react2.NumberDecrementStepper, null)))), __jsx(_react2.FormControl, {
    mb: "4",
    width: "45%"
  }, __jsx(_react2.FormLabel, {
    fontWeight: "normal",
    mb: "4"
  }, "\xC9paisseur"), __jsx(_react2.NumberInput, {
    onChange: function onChange(valueStr, value) {
      return updateContentProps({
        borderWidth: value
      });
    },
    defaultValue: block.content.borderWidth,
    min: 0,
    max: 10,
    variant: "filled"
  }, __jsx(_react2.NumberInputField, null), __jsx(_react2.NumberInputStepper, null, __jsx(_react2.NumberIncrementStepper, null), __jsx(_react2.NumberDecrementStepper, null))))), __jsx(_react2.Collapse, {
    "in": ((_block$content$border = block.content.borderWidth) != null ? _block$content$border : 0) > 0
  }, __jsx(_react2.Stack, {
    direction: "column"
  }, __jsx(_react2.InputGroup, {
    variant: "filled"
  }, __jsx(_react2.InputLeftElement, null, __jsx(_react2.Box, {
    width: "20px",
    height: "20px",
    backgroundColor: block.content.borderColor,
    transition: "background-color .25s ease"
  })), __jsx(_react2.Input, {
    onChange: function onChange(event) {
      return updateContentProps({
        borderColor: event.target.value
      });
    },
    value: block.content.borderColor,
    placeholder: "#000000"
  })), __jsx(_ColorPalette.ColorPalette, {
    currentColor: block.content.borderColor,
    onChange: function onChange(value) {
      return updateContentProps({
        borderColor: value
      });
    }
  })))))))));
};

exports.BlockButtonParams = BlockButtonParams;